export default __webpack_public_path__ + "static/media/55.030bce18.png";